export default __webpack_public_path__ + "static/media/olivine14.f30d6d3a.png";